import Axios from "../../helpers/axios";

export const fetchAllDashboardCountData = (params) => {
  return Axios.get(`/dashboard/count`, params ? { params } : null);
};

export const fetchAllDashboardChartData = (params) => {
  return Axios.get(`/dashboard/chart`, params ? { params } : null);
};
